import { Injectable } from "@angular/core";
import { ILab } from "../../models/lab-user-menu/lab";
import { ILabApplication } from "../../models/application-menu/lab-application";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { environment } from "@env/environment";
import { MenuService } from "./menu.service";
import { IMenu } from "app/models/core/menu";
import { AccountService } from "../account/account.service";
import { AuthService } from "@shared/auth/auth.service";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class SharedService {
  private api: string = environment.privateApi + "ApplicationMenu/";
  private mainApi: string = environment.privateApi + "MainMenu/";

  currentLabId: number = 0;
  currentLabName: string = "";
  currentOrelapId: string = "";
  currentApplication: ILabApplication;
  readonlyApplication: boolean = true;
  currentTab: number = 0;
  loginFailed: boolean = false;
  currentLab: ILab;
  currentPt: number = 0;
  orelapRoles: string = null;
  isAdmin:boolean = false;
  isOfficeAdmin:boolean = false;
  isQa:boolean = false;
  isAssessor:boolean = false;
  adminOnly = false;
  returnToSubmit = false;
  hasARole: boolean = false;
  private sideBarMenuCount: number = 0;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private menu: MenuService,
    private accountService: AccountService
  ) {}

  submitAndLockApplication(): Observable<any> {
    return this.http.post(
      this.api + "submitAndLock",
      this.currentApplication,
      httpOptions
    );
  }

  userAuthenticated(): boolean {
    let authenticated = this.authService.isAuthenticated();
    return authenticated;
  }

  hasRole( roles: string[]): boolean{
    let retVal = false;
    if (roles != null && this.orelapRoles != null){
      roles.forEach(item => {
        if (this.orelapRoles.includes(item)){
          retVal = true;
        }
      });
    }
    return retVal;
  }

  setRoles(){
    this.accountService.getRoles().subscribe(
      (response) => {
        this.hasARole = this.isAdmin || this.isOfficeAdmin || this.isAssessor || this.isQa;
        let flatten :string = '';
        response.forEach(item => {flatten += ',' + item + ','});
        this.orelapRoles = flatten;
        this.isAdmin = this.hasRole(['Admin']);
        this.isOfficeAdmin = this.hasRole(['Office Admin']);
        this.isAssessor = this.hasRole(['Assessor']);
        this.isQa = this.hasRole(['QA']);

        if (!(this.hasARole)){
          this.updateMenu();
        }
      },
      (error) => console.log("error", error),
      () => {}
    )
  }

  // logout(): void {
  //   this.loginFailed = false;
  //   sessionStorage.removeItem("jwt");
  //   sessionStorage.removeItem("user");
  //   this.router.navigateByUrl("/");
  //   this.menu.reset();
  //   let login: IMenu = { icon:'domain', name:'Login',  route:'lab-user-menu', type:'link' };
  //   this.menu.add(login);
  // }

  updateMenu(): void {
    this.menu.modifyLabel('Login','Lab Listing');

    if (this.isAdmin || this.isOfficeAdmin){
      let temp: IMenu = { icon:'assessment', name:'Reports',  route:'reports', type:'link' };
      this.menu.add(temp);
    }
    if (this.isAdmin || this.isOfficeAdmin){
      let temp: IMenu = { icon:'filter', name:'PT Upload',  route:'ptUpload/0', type:'link' };
      this.menu.add(temp);
    }
    if (this.isAdmin || this.isOfficeAdmin){
      let temp: IMenu = { icon:'accessibility', name:'Manage Users',  route:'manageUsers', type:'link' };
      this.menu.add(temp);
    }

    if (this.isAdmin || this.isOfficeAdmin){
      let temp: IMenu = { icon:'settings', name:'Settings',  route:'settings', type:'link' };
      this.menu.add(temp);
    }

  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }
  
  downloadHelpFile(type: string): Observable<Blob> {
    return this.http.get<Blob>(this.mainApi + 'downloadHelpFile/' + type + '/PDF', { responseType: 'blob' as 'json' });
  }

  doRedirect(url: string) {
    this.router.navigateByUrl(url);
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
}
